module.exports = __webpack_public_path__ + "static/img/order_header_bg.ceb98345.png";